import { categoricalPalette } from '../theme';

/**
 * Mappa stabile tipo di documento → colore.
 *
 * Il colore identifica il tipo, non la posizione in classifica: si assegna una volta, sull'ordine
 * categoriale fisso (i tipi ordinati per codice), e resta lo stesso in legenda, grafico, barre e
 * tabelle. Se un filtro cambia l'ordine di presentazione, i colori non si rimescolano.
 */
export const buildColorMap = (orderedKeys, palette = categoricalPalette) => {
  const map = new Map();
  orderedKeys.forEach((key) => {
    if (!map.has(key)) {
      map.set(key, palette[map.size % palette.length]);
    }
  });
  return map;
};

/** Ordine categoriale fisso: per etichetta, con i tipi senza etichetta in fondo. */
export const orderTypes = (types) =>
  [...types].sort((a, b) => {
    const left = a.codexTypeCode ?? '';
    const right = b.codexTypeCode ?? '';
    if (!left && right) return 1;
    if (left && !right) return -1;
    return left.localeCompare(right, 'it');
  });

/** Chiave usata ovunque per un tipo: l'id, con una costante per i documenti senza tipo. */
export const NO_TYPE_KEY = '__senza_tipo__';

export const typeKey = (codexTypeId) => codexTypeId ?? NO_TYPE_KEY;

export const typeLabel = (type) => type?.codexTypeCode ?? 'Senza tipo';
